module.exports = __webpack_public_path__ + "img/index3_1.e7d1d26.jpg";